const imenaDana = [
    "Nedelja", 
    "Ponedeljak", 
    "Utorak", 
    "Sreda", 
    "Četvrtak", 
    "Petak", 
    "Subota"
];

/**
 * Logika za pripremu podataka i slanje na PDF generator.
 */
export const generisiPDFServer = async (tabelaDana, radnikObj, obracunPodaci) => {
    
    // 1. Pretvaranje objekta u niz i čišćenje datuma da ne bude 'undefined'
    const detaljiDana = Object.keys(tabelaDana)
        .sort((a, b) => {
            // ISPRAVKA: sortiramo po d.datum (YYYY-MM-DD), jer su ključevi 0,1,2...
            const da = tabelaDana[a]?.datum ? String(tabelaDana[a].datum) : "";
            const db = tabelaDana[b]?.datum ? String(tabelaDana[b].datum) : "";

            const pa = da.split('-');
            const pb = db.split('-');

            if (pa.length === 3 && pb.length === 3) {
                const ta = Date.UTC(parseInt(pa[0]), parseInt(pa[1]) - 1, parseInt(pa[2]));
                const tb = Date.UTC(parseInt(pb[0]), parseInt(pb[1]) - 1, parseInt(pb[2]));
                return ta - tb;
            }

            return da.localeCompare(db);
        })
        .map(key => {
            const d = tabelaDana[key];

            // ISPRAVKA: datum uzimamo iz d.datum, ne iz ključa (key)
            const datumIso = d?.datum ? String(d.datum) : "";  // očekujemo YYYY-MM-DD
            const parts = datumIso.split('-');

            // Kreiranje datuma bez uticaja vremenske zone
            let imeDana = "";
            let formatiranDatum = "";

            if (parts.length === 3 && parts[0] && parts[1] && parts[2]) {
                const fiksniDatum = new Date(Date.UTC(
                    parseInt(parts[0]),
                    parseInt(parts[1]) - 1,
                    parseInt(parts[2])
                ));

                imeDana = imenaDana[fiksniDatum.getUTCDay()] || "";
                formatiranDatum = `${parts[2]}.${parts[1]}.${parts[0]}.`; // DD.MM.YYYY.
            } else {
                formatiranDatum = "";
                imeDana = "";
            }

            // Dodavanje loga za proveru
            console.log(`Datum: ${key}, Ime dana: ${imeDana}, Originalni podaci:`, d);

            return {
                datum: formatiranDatum,
                datum_iso: datumIso,

                dan: imeDana || "",
                prijava: d?.prijava || '00:00',
                odjava: d?.odjava || '00:00',
                status: d?.status || "Radni dan",
                ukupno: d?.ukupno || '00:00',
                redovno: d?.redovno || '00:00',
                prekovremeno: d?.prekovremeno || '00:00',
                teren: d?.teren_dodatak === 'da' ? 'DA' : 'NE'
            };
        });

    // 2. Formiranje tela zahteva
    const podaciZaServer = {
        radnik: `${radnikObj?.ime} ${radnikObj?.prezime}`,
        naslov: `IZVEŠTAJ O RADU I FINANSIJSKI OBRAČUN - ${radnikObj?.ime} ${radnikObj?.prezime}`,
        dani: detaljiDana,
        stavke: obracunPodaci.stavke,
        odbici: obracunPodaci.odbici,
        ukupno_bruto: obracunPodaci.ukupno_bruto,
        ukupno_neto: obracunPodaci.ukupno_neto
    };

    // Dodavanje loga za proveru podataka koji se šalju ka serveru
    console.log("Podaci za server:", podaciZaServer);

    // 3. Slanje ka backendu
    try {
        const response = await fetch('https://ecopell.ledscreen.rs/api/generate-plate-pdf/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(podaciZaServer)
        });

        if (response.ok) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Obracun_${radnikObj?.ime}_${radnikObj?.prezime}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } else {
            alert("Greška: Server nije uspeo da generiše PDF.");
        }
    } catch (e) {
        console.error("PDF Logic Error:", e);
        alert("Greška u komunikaciji sa PDF servisom.");
    }
};
